import type { IconData } from '@stacksjs/iconify-core'

export const natureSun: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M9.5 0h-3v1.5a1.5 1.5 0 1 0 3 0zM8 13a1.5 1.5 0 0 0-1.5 1.5V16h3v-1.5A1.5 1.5 0 0 0 8 13m4.596-11.718l2.121 2.122l-1.06 1.06a1.5 1.5 0 0 1-2.121-2.12zM4.464 11.536a1.5 1.5 0 0 0-2.12 0l-1.062 1.06l2.122 2.122l1.06-1.061a1.5 1.5 0 0 0 0-2.121M16 9.5h-1.5a1.5 1.5 0 0 1 0-3H16zM3 8a1.5 1.5 0 0 0-1.5-1.5H0v3h1.5A1.5 1.5 0 0 0 3 8m9.596 6.718l-1.06-1.061a1.5 1.5 0 0 1 2.12-2.121l1.061 1.06zM4.464 4.464a1.5 1.5 0 0 0 0-2.12l-1.06-1.062l-2.121 2.122l1.06 1.06a1.5 1.5 0 0 0 2.121 0M8 12a4 4 0 1 0 0-8a4 4 0 0 0 0 8\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default natureSun
